import { apolloProvider } from '@/modules/GraphQL';
import { apolloProvider as myStageApolloProvider } from '@/modules/myStageGraphQL';
import { CUSTOMER_FEEDACK_ANSWER, CUSTOMER_FEEDACK_ANSWER_MSB } from '@/graphql/mutations/customerFeedback';
import logger from '@/modules/Logger';

export const SaveCustomerFeedbackService = {
  msb: async (variables, successCallback, errorCallback) => {
    logger.debug(`[CFE][SaveCustomerFeedback] Save feedback to MSB GraphQL endpoint`, {
      operation: 'cfe:save-customer-feedback'
    });
    const client = myStageApolloProvider.defaultClient;
    client.mutate({
      mutation: CUSTOMER_FEEDACK_ANSWER_MSB,
      fetchPolicy: 'no-cache',
      variables: variables
    }).then(successCallback).catch((error) => {
        logger.error(`[CFE][SaveCustomerFeedback] Error saving feedback to MSB GraphQL endpoint`, {
          operation: 'cfe:save-customer-feedback',
          error: error.message
        });

        errorCallback(error);
    });
  },
  
  mbti: async (variables, successCallback, errorCallback) => {
    logger.debug(`[CFE][SaveCustomerFeedback] Save feedback to MBTI GraphQL endpoint`, {
       operation: 'cfe:save-customer-feedback'
    });
    const client = apolloProvider.defaultClient;
    client.mutate({
      mutation: CUSTOMER_FEEDACK_ANSWER,
      fetchPolicy: 'no-cache',
      variables: variables
    }).then(successCallback).catch((error) => {
        logger.error(`[CFE][SaveCustomerFeedback] Error saving feedback to MBTI GraphQL endpoint`, {
          operation: 'cfe:save-customer-feedback',
          error: error.message
        });

        errorCallback(error);
    });
  },
};

// Route legacy endpoint to MBTI, because this API does not have FuelPHP version
SaveCustomerFeedbackService.legacy = SaveCustomerFeedbackService.mbti;
